import { useState, useEffect } from 'react'
import { postDataAPI } from '../lib/api'

type UserPermissions = {
  sections: string[]
}

export function useUserPermissions() {
  const [permissions, setPermissions] = useState<UserPermissions | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const user = localStorage.getItem('dizeeUser')
        const token = localStorage.getItem('dizeeToken')
        const selectedArtist = localStorage.getItem('selectedArtist')
        
        if (!user || !token) {
          setLoading(false)
          return
        }

        const userData = JSON.parse(user)
        const parsedToken = typeof token === 'string' ? token : JSON.parse(token)

        // If user is an artist (not a team member), they have all permissions
        if (userData.professionRole === 'artist' && !selectedArtist) {
          setPermissions(null) // null means all permissions
          setLoading(false)
          return
        }

        // If team member is managing an artist, fetch their permissions
        if (selectedArtist && ['manager', 'support'].includes(userData.professionRole)) {
          const artist = JSON.parse(selectedArtist)
          const res = await postDataAPI(
            'team/member-permissions',
            { 
              artistId: artist._id || artist.id,
              teamMemberEmail: userData.email 
            },
            parsedToken
          )
          
          const data = res?.data?.data ?? res?.data ?? res
          setPermissions(data?.permissions || { sections: [] })
        }
        
        setLoading(false)
      } catch (error) {
        console.error('Error fetching permissions:', error)
        setPermissions({ sections: [] })
        setLoading(false)
      }
    }

    fetchPermissions()
  }, [])

  const hasPermission = (sectionId: string): boolean => {
    // If permissions is null, user has all permissions (artist)
    if (permissions === null) return true
    
    // If no permissions loaded yet, deny access
    if (!permissions) return false
    
    // Check if user has permission for this section
    return permissions.sections.includes(sectionId)
  }

  return { permissions, loading, hasPermission }
}
